import { TZDateMini } from '@date-fns/tz';
import { useEffect, useMemo } from 'react';

import { parseTimeAsTimeValue } from '@dynatrace-sdk/units';
import { getTimezone } from '@dynatrace-sdk/user-preferences';

import { createSdkLogger } from '../../../core/sdk/sdk-logger.js';

const SDK_LOGGER_NAME = 'Strato: Date Component';

/**
 * Hook to check and log when the min is larger than the max.
 * @internal
 */
export const useMinMaxLogger = (
  min?: string,
  max?: string,
  componentName?: string,
) => {
  const logger = useMemo(
    () => createSdkLogger(componentName ?? SDK_LOGGER_NAME),
    [componentName],
  );
  const timezone = getTimezone();

  useEffect(() => {
    if (min && max) {
      const minDate = parseTimeAsTimeValue(min);
      const maxDate = parseTimeAsTimeValue(max);
      if (
        minDate &&
        maxDate &&
        new TZDateMini(minDate.absoluteDate, timezone).getTime() >=
          new TZDateMini(maxDate.absoluteDate, timezone).getTime()
      ) {
        logger.error(
          `Min prop is larger than the max prop. Min: ${min}, Max: ${max}`,
        );
      }
    }
  }, [min, max, logger, timezone]);
};
